import styled from 'styled-components'
import { compose, space, layout, position, flexbox } from 'styled-system'
const Img = styled.img`
  ${compose(space, layout, position, flexbox)}
`
export default Img
